export default function Hero() {
  return (
    <section id="beranda" className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Volunteers%20in%20matching%20green%20shirts%20distributing%20food%20aid%20boxes%20and%20shaking%20hands%20with%20grateful%20families%20at%20a%20community%20center%20in%20Malaysia%2C%20warm%20golden%20hour%20sunlight%2C%20hopeful%20and%20compassionate%20atmosphere%2C%20soft%20warm%20tones%2C%20editorial%20documentary%20photography%20with%20gentle%20depth%20of%20field%20and%20clean%20harmonious%20composition&width=1600&height=900&seq=hero-ngo-01&orientation=landscape"
        alt="Sukarelawan Kelab Kemajuan Insan Malaysia membantu komuniti"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>

      <div className="relative z-10 w-full max-w-4xl px-4 md:px-6 text-center">
        <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/90 text-foreground-950 text-xs md:text-sm font-semibold mb-5 animate-fade-up">
          <i className="ri-shield-check-line"></i>
          Pertubuhan Berdaftar · PPM-002-14-31032015
        </span>
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-semibold text-background-50 leading-tight animate-fade-up delay-1">
          Membangun Insan,{" "}
          <span className="text-accent-400">Menyebarkan Rahmat</span>
        </h1>
        <p className="mt-5 text-sm md:text-lg text-background-50/85 max-w-2xl mx-auto leading-relaxed animate-fade-up delay-2">
          Kelab Kemajuan Insan Malaysia berkhidmat membantu keluarga yang
          memerlukan melalui program kebajikan, pendidikan, kesihatan dan
          bantuan kemanusiaan di seluruh Malaysia.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3 animate-fade-up delay-3">
          <a
            href="#sumbangan"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-accent-500 text-foreground-950 font-semibold text-sm md:text-base whitespace-nowrap cursor-pointer hover:bg-accent-400 transition-colors"
          >
            Derma Sekarang
          </a>
          <a
            href="#sukarelawan"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full border border-background-50/60 text-background-50 font-semibold text-sm md:text-base whitespace-nowrap cursor-pointer hover:bg-background-50/15 transition-colors"
          >
            Jadilah Sukarelawan
          </a>
        </div>
      </div>
    </section>
  );
}